export default "__VITE_ASSET__490ec7f2__"